import * as types from './roomsActionTypes';
import * as chatroomTypes from './../Chatroom/chatroomActionTypes';
import { firebase } from './../../utils/firebase/firebase';

var createRoomInProgress = function createRoomInProgress() {
    return {
        type: types.CREATE_ROOM
    };
};

var createRoomInSuccess = function createRoomInSuccess() {
    return {
        type: types.CREATE_ROOM_SUCCESS
    };
};

var createRoomInError = function createRoomInError(errorMessage) {
    return {
        type: types.CREATE_ROOM_ERROR,
        errorMessage: errorMessage
    };
};

export var createRoom = function createRoom(roomName, metaData, enterRoom) {
    return function (dispatch) {
        dispatch(createRoomInProgress());

        firebase.firebaseApp.database().ref('rooms').push({
            roomName: roomName,
            metaData: metaData,
            createdAt: new Date().getTime(),
            lastSeen: { admin: 0 }
        }).then(function (result) {
            dispatch(createRoomInSuccess());
            if (enterRoom === true) {
                dispatch(selectRoom(result.getKey(), roomName));
            }
        }).catch(function (error) {
            dispatch(createRoomInError(error.message));
        });
    };
};

export var retrieveRooms = function retrieveRooms(key, roomName, metaData, messagesData) {
    var counter = messagesData.counter,
        lastUpdate = messagesData.lastUpdate;

    return {
        type: types.RETRIEVE_ROOMS,
        key: key,
        roomName: roomName,
        metaData: metaData,
        counter: counter,
        lastUpdate: lastUpdate
    };
};

export var selectRoom = function selectRoom(chatroomId, chatroomName) {
    return {
        type: chatroomTypes.ENTER_CHATROOM,
        chatroomId: chatroomId,
        chatroomName: chatroomName
    };
};

export var resetRoomsList = function resetRoomsList() {
    return {
        type: types.RESET_ROOMS_LIST
    };
};

var reorderRoomsSuccess = function reorderRoomsSuccess(rooms) {
    return {
        type: types.REORDER_ROOMS_SUCCESS,
        rooms: rooms
    };
};

export var reorderRooms = function reorderRooms(key, messagesData) {
    return function (dispatch, getState) {
        var rooms = getState().rooms.rooms;
        var room = rooms.find(function (element) {
            return element.chatroomId === key;
        });
        var index = rooms.indexOf(room);

        //create a new variable for immutability
        var newRooms = [].concat(rooms);

        if (room.counter.messages !== messagesData.counter.messages || room.counter.reportUnview !== messagesData.counter.reportUnview) {
            //new message
            room.counter = messagesData.counter;
            newRooms.splice(index, 1);
            newRooms.unshift(room);
        } else {
            newRooms[index].counter = messagesData.counter;
        }

        dispatch(reorderRoomsSuccess(newRooms));
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Rooms/roomsActions.js
// module id = 61
// module chunks = 0